export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-16.5dc97f30.jpg";